import WorkersView from "../../views/FreelanceCompany/WorkersView";

const WorkersPage = () => <WorkersView />;

export default WorkersPage;
